import type { Language } from "@app/constants";

interface Messages {
	header: string;
	markAllAsRead: string;
	clearAll: string;
	noNotifications: string;
}

type Message = { [key in Language]: Messages };

const messages: Message = {
	en: {
		header: "Notifications",
		markAllAsRead: "Mark all as read",
		clearAll: "Clear all",
		noNotifications: "No notifications",
	},
};

export default messages;
